import { useState } from "react";

interface Episode {
  index: number;
  title: string;
  desc: string;
}

export default function EpisodeList({ episodes }: { episodes: Episode[] }) {
  const [selected, setSelected] = useState(episodes[0]?.index ?? 1);
  const current = episodes.find((item) => item.index === selected) ?? episodes[0];

  if (episodes.length === 0) return null;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-wrap gap-2">
        {episodes.map((ep) => (
          <button
            key={ep.index}
            type="button"
            onClick={() => setSelected(ep.index)}
            className={`h-9 w-9 whitespace-nowrap rounded-md text-sm font-medium transition-colors ${
              selected === ep.index
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
            }`}
          >
            {ep.index}
          </button>
        ))}
      </div>
      {current && (
        <div className="mt-4 rounded-md bg-background-100 p-4">
          <h4 className="font-heading text-base font-semibold text-foreground-900">
            第 {current.index} 集 · {current.title}
          </h4>
          <p className="mt-1 text-sm leading-relaxed text-foreground-600">{current.desc}</p>
        </div>
      )}
    </div>
  );
}